import script from "./CallComposeModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CallComposeModal.vue?vue&type=script&setup=true&lang=ts"

import "./CallComposeModal.vue?vue&type=style&index=0&id=4f8793e9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f8793e9"]])

export default __exports__